module.exports = __webpack_public_path__ + "static/media/rulesOne.bfea8cac.png";